import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'DecodeUTF8'})
export class DecodeUTF8Pipe implements PipeTransform {
    transform(utf8String) {
        // MO-FE-7G: templates pass null/non-string from API fields; never throw in a pipe.
        if (utf8String == null || utf8String === '') return '';
        if (typeof utf8String != 'string') return '';
        // note: decode 3-byte chars first as decoded 2-byte strings could appear to be 3-byte char!
        const unicodeString = utf8String.replace(
            /[\u00e0-\u00ef][\u0080-\u00bf][\u0080-\u00bf]/g,  // 3-byte chars
            function(c) {  // (note parentheses for precedence)
                var cc = ((c.charCodeAt(0)&0x0f)<<12) | ((c.charCodeAt(1)&0x3f)<<6) | ( c.charCodeAt(2)&0x3f);
                return String.fromCharCode(cc); }
        ).replace(
            /[\u00c0-\u00df][\u0080-\u00bf]/g,                 // 2-byte chars
            function(c) {  // (note parentheses for precedence)
                var cc = (c.charCodeAt(0)&0x1f)<<6 | c.charCodeAt(1)&0x3f;
                return String.fromCharCode(cc); }
        );
        return unicodeString;
      }

}
